import { EmblaOptionsType } from "embla-carousel";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import React, { useCallback, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { Button } from "../ui/button";
import { Thumb } from "./EmblaCarouselThumbsButton";
import styles from "./mediaswiper.module.css";

type PropType = {
  slides: any[];
  options?: EmblaOptionsType;
};

const MediaCarousel: React.FC<PropType> = (props) => {
  const { slides, options } = props;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [emblaMainRef, emblaMainApi] = useEmblaCarousel({
    ...options,
    loop: true,
  });
  const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
    containScroll: "keepSnaps",
    dragFree: true,
  });

  const onThumbClick = useCallback(
    (index: number) => {
      setSelectedIndex(index);
      if (!emblaMainApi || !emblaThumbsApi) return;
      emblaMainApi.scrollTo(index);
    },
    [emblaMainApi, emblaThumbsApi]
  );

  const onSelect = useCallback(() => {
    if (!emblaMainApi || !emblaThumbsApi) return;
    setSelectedIndex(emblaMainApi.selectedScrollSnap());
    emblaThumbsApi.scrollTo(emblaMainApi.selectedScrollSnap());
  }, [emblaMainApi, emblaThumbsApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaMainApi) return;
    onSelect();

    emblaMainApi.on("select", onSelect).on("reInit", onSelect);
  }, [emblaMainApi, onSelect]);

  const handleNext = () => {
    if (emblaMainApi) {
      emblaMainApi.scrollNext();
    }
  };

  const handlePrev = () => {
    if (emblaMainApi) {
      emblaMainApi.scrollPrev();
    }
  };

  return (
    <>
      <div className={`${styles.embla} grid justify-center`}>
        {/* Video */}
        <div>
          <div className={`${styles.embla__viewport}`} ref={emblaMainRef}>
            <div className={`${styles.embla__container}`}>
              {slides.map((slide) => (
                <div className={`${styles.embla__slide}`} key={slide.id}>
                  <div className={`${styles.embla__slide__number} `}>
                    {/* <YouTube videoId={slide.url} /> */}
                    <ReactPlayer url={slide.url} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Slider */}
        <div>
          <div className={`${styles["embla-thumbs"]}   `}>
            <div
              className={`${styles["embla-thumbs__viewport"]}  `}
              ref={emblaThumbsRef}
            >
              <div className={`${styles[""]}  flex justify-center  `}>
                {slides.map((index) => (
                  <Thumb
                    key={index}
                    onClick={() => onThumbClick(index.id)}
                    selected={index === selectedIndex}
                    index={index}
                    url={index.thumbnail}
                  />
                ))}
              </div>
            </div>
          </div>
          {/* Btn Prev Next */}
          <div className="container">
            <div className="flex justify-center mt-3 space-x-2 ">
              <Button
                variant="outline"
                size="icon"
                className="bg-primary group "
                onClick={handlePrev}
              >
                <ChevronLeft className="w-4 h-4 text-white next group-hover:text-black" />
              </Button>
              <Button
                variant="outline"
                size="icon"
                className="bg-primary group"
                onClick={handleNext}
              >
                <ChevronRight className="w-4 h-4 text-white back group-hover:text-black" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MediaCarousel;
